import React, { useState, useEffect } from 'react'
import { api } from '../../utils/api'

const STATUS = {
  set: { label: 'Set', badge: 'badge-success' },
  missing: { label: 'Missing', badge: 'badge-warning' },
  unlisted: { label: 'Not in the expected list', badge: 'badge-error' },
}

function WorkerCard({ block }) {
  if (block.error) {
    return (
      <div className="card">
        <h3>{block.worker}</h3>
        <p className="text-warning">{block.error}</p>
      </div>
    )
  }
  return (
    <div className="card">
      <h3>{block.worker}</h3>
      <p>Environment: <span className={`badge ${block.environment === 'production' ? 'badge-success' : 'badge-warning'}`}>{block.environment ?? 'not set'}</span></p>
      {block.problems.length > 0 && (
        <ul className="text-warning">
          {block.problems.map((p) => <li key={p}>{p}</li>)}
        </ul>
      )}
      <h4>Derived settings</h4>
      <ul>
        {block.derived.map((d) => (
          <li key={d.name}><strong>{d.name}:</strong> {d.value} <span className="text-muted">({d.because})</span></li>
        ))}
      </ul>
      <table className="table">
        <thead><tr><th>Name</th><th>Kind</th><th>Status</th><th>Value</th><th>Problem</th></tr></thead>
        <tbody>
          {block.rows.map((r) => (
            <tr key={r.name}>
              <td>{r.name}</td>
              <td>{r.kind}</td>
              <td><span className={`badge ${STATUS[r.status].badge}`}>{STATUS[r.status].label}</span></td>
              <td>{r.value ?? ''}</td>
              <td className={r.problem ? 'text-warning' : ''}>{r.problem ?? ''}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default function EnvironmentConfig() {
  const [workers, setWorkers] = useState(null)
  const [error, setError] = useState(null)
  useEffect(() => {
    api.get('/api/admin/environment-config').then((d) => setWorkers(d.workers), (e) => setError(e.message))
  }, [])
  if (error) return <div className="alert alert-error">{error}</div>
  if (!workers) return <p className="text-muted">Loading...</p>
  return <div>{workers.map((w) => <WorkerCard key={w.worker} block={w} />)}</div>
}
